













import { Box, SocialIcon, ProfileIcon, Flex } from '../../atoms'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { EMAIL_PROVIDER } from '@/constant/provider'
import { DEFAULT_SOCIAL_DISPLAYNAME } from '@/constant/social'

@Component({
  components: {
    Flex,
    Box,
    SocialIcon,
    ProfileIcon
  }
})
export default class SocialBox extends Vue {
  @Prop({ required: true, type: String }) readonly social!: string
  @Prop({ type: String, default: '' }) readonly displayName?: string
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: String, default: '' }) readonly profilePic?: string
  @Prop({ type: String, default: '' }) readonly customClass?: string

  get showSocialIcon(): boolean {
    return this.social !== EMAIL_PROVIDER
  }
  get getSocialDisplayName(): string {
    if (this.displayName) {
      return this.displayName
    }
    return DEFAULT_SOCIAL_DISPLAYNAME(this.social)
  }
}
